export class PreferredLoginMethod {
    static readonly MICROSOFT = 'microsoft';
    static readonly GOOGLE = 'google';
    static readonly OKTA = 'okta';
    static readonly USERNAME = "username";
}